import styled, { css } from "styled-components";
import { TGradientVariant } from "./ProgressiveBlurGradient.types";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";

export const Container = styled.div<{
  $maxWidth: string;
  $isRounded?: boolean;
}>`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  max-width: ${({ $maxWidth }) => $maxWidth};
  overflow: hidden;

  ${({ $isRounded }) =>
    $isRounded &&
    css`
      border-radius: 8px;
    `}

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    max-width: 100%;
    max-height: 15%;
    top: -2px;
    border-radius: 0;
  }
`;

export const RelativeContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const BlurFilter = styled.div`
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;

  &:nth-child(1) {
    backdrop-filter: blur(1px);
    width: 100%;
    mask: linear-gradient(
      to left,
      rgba(0, 0, 0, 0) 10%,
      rgba(0, 0, 0, 1) 20%,
      rgba(0, 0, 0, 1) 40%,
      rgba(0, 0, 0, 0) 50%
    );

    @media ${BREAKPOINTS.TABLET_AND_DOWN} {
      mask: linear-gradient(
        to top,
        rgba(0, 0, 0, 0) 10%,
        rgba(0, 0, 0, 1) 20%,
        rgba(0, 0, 0, 1) 40%,
        rgba(0, 0, 0, 0) 50%
      );
    }
  }

  &:nth-child(2) {
    backdrop-filter: blur(2px);
    width: 100%;
    mask: linear-gradient(
      to left,
      rgba(0, 0, 0, 0) 15%,
      rgba(0, 0, 0, 1) 30%,
      rgba(0, 0, 0, 1) 50%,
      rgba(0, 0, 0, 0) 60%
    );

    @media ${BREAKPOINTS.TABLET_AND_DOWN} {
      mask: linear-gradient(
        to top,
        rgba(0, 0, 0, 0) 15%,
        rgba(0, 0, 0, 1) 30%,
        rgba(0, 0, 0, 1) 50%,
        rgba(0, 0, 0, 0) 60%
      );
    }
  }

  &:nth-child(3) {
    backdrop-filter: blur(4px);
    width: 100%;
    mask: linear-gradient(
      to left,
      rgba(0, 0, 0, 0) 20%,
      rgba(0, 0, 0, 1) 40%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 0) 70%
    );

    @media ${BREAKPOINTS.TABLET_AND_DOWN} {
      mask: linear-gradient(
        to top,
        rgba(0, 0, 0, 0) 20%,
        rgba(0, 0, 0, 1) 40%,
        rgba(0, 0, 0, 1) 60%,
        rgba(0, 0, 0, 0) 70%
      );
    }
  }

  &:nth-child(4) {
    backdrop-filter: blur(8px);
    width: 100%;
    mask: linear-gradient(
      to left,
      rgba(0, 0, 0, 0) 40%,
      rgba(0, 0, 0, 1) 60%,
      rgba(0, 0, 0, 1) 80%,
      rgba(0, 0, 0, 0) 90%
    );

    @media ${BREAKPOINTS.TABLET_AND_DOWN} {
      mask: linear-gradient(
        to top,
        rgba(0, 0, 0, 0) 40%,
        rgba(0, 0, 0, 1) 60%,
        rgba(0, 0, 0, 1) 80%,
        rgba(0, 0, 0, 0) 90%
      );
    }
  }

  &:nth-child(5) {
    backdrop-filter: blur(16px);
    width: 100%;
    mask: linear-gradient(to left, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 1) 80%);

    @media ${BREAKPOINTS.TABLET_AND_DOWN} {
      mask: linear-gradient(to top, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 1) 80%);
    }
  }

  &:nth-child(6) {
    z-index: 10;
    background-filter: blur(64px);
    mask: linear-gradient(to left, rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, 1) 100%);

    @media ${BREAKPOINTS.TABLET_AND_DOWN} {
      mask: linear-gradient(
        to top,
        rgba(0, 0, 0, 0) 70%,
        rgba(0, 0, 0, 1) 100%
      );
    }
  }
`;

export const Gradient = styled.div<{
  $variant: TGradientVariant;
  $customGradientColor?: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to left, transparent, #ffffff);

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    background: linear-gradient(to top, transparent, #ffffff);
  }

  ${({ $variant }) =>
    $variant === "dark" &&
    `
    background: linear-gradient(to left, transparent, #000000);

    @media ${BREAKPOINTS.TABLET_AND_DOWN} {
        background: linear-gradient(to top, transparent, #000000);
    }
  `}

  ${({ $customGradientColor }) =>
    $customGradientColor &&
    css`
      background: linear-gradient(
        to left,
        transparent,
        ${$customGradientColor}
      );

      @media ${BREAKPOINTS.TABLET_AND_DOWN} {
        background: linear-gradient(
          to top,
          transparent,
          ${$customGradientColor}
        );
      }
    `}
`;
